/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PlanMarkerPage } from './plan-marker.page';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PlanMarkerCreateModule } from 'src/app/_components/plan-marker-create/plan-marker-create.module';
import { PinSelectModalModule } from 'src/app/_components/pin-select-modal/pin-select-modal.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PhotoViewModalComponentModule } from 'src/app/_components/photo-view-modal/photo-view-modal.module';

const routes: Routes = [
  {
    path: '',
    component: PlanMarkerPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    SharedModule,
    PlanMarkerCreateModule,
    PinSelectModalModule,
    ScrollingModule,
    PhotoViewModalComponentModule,
  ],
  declarations: [PlanMarkerPage],
})
export class PlanMarkerModule {}
